import React from 'react';

const Youtube = ({ className }) => {
    return (
        <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_270_38441)">
                <path d="M26.4439 2.97514C26.1325 1.81193 25.2206 0.89478 24.0641 0.581607C21.9513 0 13.4999 0 13.4999 0C13.4999 0 5.04858 0 2.93574 0.559238C1.80148 0.872411 0.867377 1.81193 0.556011 2.97514C0 5.10025 0 9.50704 0 9.50704C0 9.50704 0 13.9362 0.556011 16.0389C0.867377 17.2022 1.77923 18.1193 2.93574 18.4325C5.07082 19.0141 13.4999 19.0141 13.4999 19.0141C13.4999 19.0141 21.9513 19.0141 24.0641 18.4548C25.2206 18.1417 26.1325 17.2245 26.4439 16.0613C26.9999 13.9362 26.9999 9.52941 26.9999 9.52941C26.9999 9.52941 27.0221 5.10025 26.4439 2.97514Z" fill="white" />
                <path d="M17.8368 9.5068L10.8088 5.43555V13.578L17.8368 9.5068Z" fill="#333333" />
            </g>
            <defs>
                <clipPath id="clip0_270_38441">
                    <rect width="27" height="19.0141" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Youtube;